import { render, staticRenderFns } from "./changeTransferCodeModal.vue?vue&type=template&id=5255164c&scoped=true&"
import script from "./changeTransferCodeModal.vue?vue&type=script&lang=js&"
export * from "./changeTransferCodeModal.vue?vue&type=script&lang=js&"
import style0 from "./changeTransferCodeModal.vue?vue&type=style&index=0&id=5255164c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5255164c",
  null
  
)

export default component.exports